import { Status } from "../../models/Status";

export const SET_PASSWORD_STATUS = "SET_PASSWORD_STATUS";

export type IState = {
  status: Status;
};
